// extracted by mini-css-extract-plugin
export default {"ldsRoller":"styles_ldsRoller__mpnHL"};